import { Role } from 'src/types/sentinel';

export const normalizeRole = (rawRole: string | undefined): Role | undefined => {
	if (!rawRole) return undefined;
	return rawRole.replace('_', '-') as Role;
};
